// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1-arK","loaderOuter":"PageOverlayLoader_loaderOuter__2gs4G"};